module.exports = "pegasus/assets/blocks/column-3-theme2.png";